import http from '@/support/plugin/axios'

export const 

//Obter lista de sorteios
getRafflesByCompanyIdAndCurrentContactId = (companyId) => http.get(`companies/${companyId}/contacts/current/raffles`),

//Obter detalhe do sorteio
getRaffleByIdAndCompanyIdAndCurrentContactId = (companyId, sweepstakesId) => http.get(`companies/${companyId}/contacts/current/raffles/${sweepstakesId}`),

//Ativar número da sorte
activateRaffleByIdAndCompanyIdAndCurrentContactId = (companyId, sweepstakesId) => http.patch(`companies/${companyId}/contacts/current/raffles/${sweepstakesId}/activate`)